import React from 'react';

const PlusSVGs = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M9.5 17.5C13.9 17.5 17.5 13.9 17.5 9.5C17.5 5.1 13.9 1.5 9.5 1.5C5.1 1.5 1.5 5.1 1.5 9.5C1.5 13.9 5.1 17.5 9.5 17.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.30078 9.5H12.7008"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.7V6.30005"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusSVGs;
